import { render, staticRenderFns } from "./PerCode.vue?vue&type=template&id=1f0e659a&scoped=true&"
import script from "./PerCode.vue?vue&type=script&lang=ts&"
export * from "./PerCode.vue?vue&type=script&lang=ts&"
import style0 from "./PerCode.vue?vue&type=style&index=0&id=1f0e659a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e659a",
  null
  
)

export default component.exports